import {Observable} from 'rxjs/Observable';
import {doPickFile} from './lettables/pickFile';
import {doCropOriginal} from './lettables/cropOriginal';
import {doResizeImage, doStoreImage} from "./lettables/resizeImage";
import {doImageMetadata} from "./lettables/imageMetadata";
import {doTransformImage} from "./lettables/transformImage";

// Static implementations of lettables
Object.defineProperty(Observable, 'DB', {
  get: function () {
    return {
      pickFile: (options) => new Observable((observer) => doPickFile(observer, options)),
      cropOriginal: (originalImage, imageType) => new Observable((observer) => doCropOriginal(observer, {
        originalImage,
        imageType
      })),
      resizeImage: (file, width, height, fit) => new Observable((observer) => doResizeImage(observer, file, width, height, fit)),
      imageMetadata: (file, options) => new Observable((observer) => doImageMetadata(observer, file, options)),
      transformImage: (file, transformOptions) => new Observable((observer) => doTransformImage(observer, file, transformOptions)),
      storeImage: (file) => new Observable((observer) => doStoreImage(observer, file)),
    }
  }
});


// WEBPACK FOOTER //
// ./public/observables/ObservableExtensions.js